/**
 * Backend `HtsChatStatus` (#13383). `Completed` and `NoAnswer` are finished but still active: only a restart, a description
 * edit on the line or another conversation linked to the line ends them.
 */
export enum enumHtsChatStatus {
  AwaitingAnswer = 1,
  Completed = 2,
  /** The classifier could not determine a code — a normal outcome (200), not an error; the line passes the gate without a code. */
  NoAnswer = 3,
}
